<template>
  <div
    class="main main-really-raised w-50 ml-auto mr-auto pdf-annual-report-cn"
  >
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card card-signup no-shadow">
            <br /><br />
            <div
              class="card-header card-header-primary negative blue-grad w-50"
            >
              <h4 class="card-title">
                {{ $t("message.contragent_search.annual_report")
                }}<span v-if="doc_additional && doc_additional.request"
                  >: {{ doc_additional.request }}</span
                >
              </h4>
            </div>
            <br />

            <div
              v-for="(result, index) in results"
              :key="'res-an-rep-' + index"
              class="result-block mb-3"
            >
              <div>
                <!-- <div class="row">
                                    <div class="col-6"><h5>{{result.basic_info.CompanyName}}</h5></div>
                                    <div class="col-6 text-right">
                                        {{result.basic_info.RegNo}}
                                    </div>
                                </div>
                                <hr> -->
                <h5
                  class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                >
                  {{ $t("message.contragent_search.BasicInfo") }}
                </h5>
                <div>
                  <div>
                    <b-table
                      :fields="basic_info_fields_1"
                      :items="resultsData(result, 'BasicInfoData')"
                    ></b-table>
                  </div>
                </div>
                <div>
                  <div>
                    <b-table
                      :fields="basic_info_fields_2"
                      :items="resultsData(result, 'BasicInfoData')"
                    ></b-table>
                  </div>
                </div>
                <div>
                  <div>
                    <b-table
                      :fields="basic_info_fields_3"
                      :items="resultsData(result, 'BasicInfoData')"
                    ></b-table>
                  </div>
                </div>
                <h5
                  class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                >
                  {{ $t("message.contragent_search.AssetsData") }}
                </h5>
                <div>
                  <div>
                    <b-table
                      :fields="assets_data_fields_1"
                      :items="resultsData(result, 'AssetsData')"
                    ></b-table>
                  </div>
                </div>
                <div>
                  <div>
                    <b-table
                      :fields="assets_data_fields_2"
                      :items="resultsData(result, 'AssetsData')"
                    ></b-table>
                  </div>
                </div>
                <template
                  v-if="resultsDataList(result, 'ChangeList').length > 0"
                >
                  <h5
                    class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                  >
                    {{ $t("message.contragent_search.ChangeList") }}
                  </h5>
                  <div>
                    <div>
                      <b-table
                        :fields="change_fields"
                        :items="resultsDataList(result, 'ChangeList')"
                      ></b-table>
                    </div>
                  </div>
                </template>
                <template
                  v-if="resultsDataList(result, 'InvestInfoList').length > 0"
                >
                  <h5
                    class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                  >
                    {{ $t("message.contragent_search.InvestInfoList") }}
                  </h5>
                  <div>
                    <div>
                      <b-table
                        :fields="invest_info_fields"
                        :items="resultsDataList(result, 'InvestInfoList')"
                      ></b-table>
                    </div>
                  </div>
                </template>
                <template
                  v-if="resultsDataList(result, 'PartnerList').length > 0"
                >
                  <h5
                    class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                  >
                    {{ $t("message.contragent_search.PartnerList") }}
                  </h5>
                  <div>
                    <div>
                      <b-table
                        :fields="partner_fields"
                        :items="resultsDataList(result, 'PartnerList')"
                      ></b-table>
                    </div>
                  </div>
                </template>
                <template
                  v-if="
                    resultsDataList(result, 'ProvideAssuranceList').length > 0
                  "
                >
                  <h5
                    class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                  >
                    {{ $t("message.contragent_search.ProvideAssuranceList") }}
                  </h5>
                  <div>
                    <div>
                      <b-table
                        :fields="provide_assurance_fields"
                        :items="resultsDataList(result, 'ProvideAssuranceList')"
                      ></b-table>
                    </div>
                  </div>
                </template>
                <template
                  v-if="resultsDataList(result, 'StockChangeList').length > 0"
                >
                  <h5
                    class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                  >
                    {{ $t("message.contragent_search.StockChangeList") }}
                  </h5>
                  <div>
                    <div>
                      <b-table
                        :fields="stock_change_fields"
                        :items="resultsDataList(result, 'StockChangeList')"
                      ></b-table>
                    </div>
                  </div>
                </template>
                <template
                  v-if="resultsDataList(result, 'WebSiteList').length > 0"
                >
                  <h5
                    class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                  >
                    {{ $t("message.contragent_search.WebSiteList") }}
                  </h5>
                  <div>
                    <div>
                      <b-table
                        :fields="website_fields"
                        :items="resultsDataList(result, 'WebSiteList')"
                      ></b-table>
                    </div>
                  </div>
                </template>
                <template
                  v-if="
                    resultsDataList(result, 'AdministrationLicenseList')
                      .length > 0
                  "
                >
                  <h5
                    class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                  >
                    {{
                      $t("message.contragent_search.AdministrationLicenseList")
                    }}
                  </h5>
                  <div>
                    <div>
                      <b-table
                        :fields="administration_license_fields"
                        :items="
                          resultsDataList(result, 'AdministrationLicenseList')
                        "
                      ></b-table>
                    </div>
                  </div>
                </template>
                <template
                  v-if="resultsDataList(result, 'BranchList').length > 0"
                >
                  <h5
                    class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                  >
                    {{ $t("message.contragent_search.BranchList") }}
                  </h5>
                  <div>
                    <div>
                      <b-table
                        :fields="branch_fields"
                        :items="resultsDataList(result, 'BranchList')"
                      ></b-table>
                    </div>
                  </div>
                </template>
                <template
                  v-if="resultsDataList(result, 'EmployeeList').length > 0"
                >
                  <h5
                    class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                  >
                    {{ $t("message.contragent_search.EmployeeList") }}
                  </h5>
                  <div>
                    <div>
                      <b-table
                        :fields="employee_fields"
                        :items="resultsDataList(result, 'EmployeeList')"
                      ></b-table>
                    </div>
                  </div>
                </template>
                <h5
                  class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                >
                  {{ $t("message.contragent_search.SocialInsurance") }}
                </h5>
                <div>
                  <div>
                    <b-table
                      :fields="social_insurance_fields_1"
                      :items="resultsData(result, 'SocialInsurance')"
                    ></b-table>
                  </div>
                </div>
                <div>
                  <div>
                    <b-table
                      :fields="social_insurance_fields_2"
                      :items="resultsData(result, 'SocialInsurance')"
                    ></b-table>
                  </div>
                </div>
                <div>
                  <div>
                    <b-table
                      :fields="social_insurance_fields_3"
                      :items="resultsData(result, 'SocialInsurance')"
                    ></b-table>
                  </div>
                </div>
                <div>
                  <div>
                    <b-table
                      :fields="social_insurance_fields_4"
                      :items="resultsData(result, 'SocialInsurance')"
                    ></b-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  props: ["user_id", "doc_id", "doc", "goods", "doc_additional"],
  data() {
    return {
      current_tab: 0,
      response_info: {},
      service_info: {},
      service_info_objects: {},
      keyWord: "",
      results: {},
      basic_info_fields_1: [
        {
          key: "RegNo",
          label: this.$t("message.contragent_search.RegNo"),
        },
        {
          key: "CompanyName",
          label: this.$t("message.contragent_search.CompanyName"),
        },
        {
          key: "CreditCode",
          label: this.$t("message.contragent_search.CreditCode"),
        },
        {
          key: "OperatorName",
          label: this.$t("message.contragent_search.OperatorName"),
        },
        {
          key: "ContactNo",
          label: this.$t("message.contragent_search.ContactNo"),
        },
        {
          key: "PostCode",
          label: this.$t("message.contragent_search.PostCode"),
        },
        {
          key: "Address",
          label: this.$t("message.contragent_search.Address"),
        },
        {
          key: "EmailAddress",
          label: this.$t("message.contragent_search.EmailAddress"),
        },
      ],
      basic_info_fields_2: [
        {
          key: "RegNo",
          label: this.$t("message.contragent_search.RegNo"),
        },
        {
          key: "IsStockRightTransfer",
          label: this.$t("message.contragent_search.IsStockRightTransfer"),
        },
        {
          key: "Status",
          label: this.$t("message.contragent_search.Status"),
        },
        {
          key: "HasWebSite",
          label: this.$t("message.contragent_search.HasWebSite"),
        },
        {
          key: "HasNewStockOrByStock",
          label: this.$t("message.contragent_search.HasNewStockOrByStock"),
        },
        {
          key: "EmployeeCount",
          label: this.$t("message.contragent_search.EmployeeCount"),
        },
        {
          key: "BelongTo",
          label: this.$t("message.contragent_search.BelongTo"),
        },
        {
          key: "CapitalAmount",
          label: this.$t("message.contragent_search.CapitalAmount"),
        },
        {
          key: "HasProvideAssurance",
          label: this.$t("message.contragent_search.HasProvideAssurance"),
        },
      ],
      basic_info_fields_3: [
        {
          key: "RegNo",
          label: this.$t("message.contragent_search.RegNo"),
        },
        {
          key: "OperationPlaces",
          label: this.$t("message.contragent_search.OperationPlaces"),
        },
        {
          key: "OperationPlaces",
          label: this.$t("message.contragent_search.OperationPlaces"),
        },
        {
          key: "MainType",
          label: this.$t("message.contragent_search.MainType"),
        },
        {
          key: "OperationDuration",
          label: this.$t("message.contragent_search.OperationDuration"),
        },
        {
          key: "IfContentSame",
          label: this.$t("message.contragent_search.IfContentSame"),
        },
        {
          key: "DifferentContent",
          label: this.$t("message.contragent_search.DifferentContent"),
        },
        {
          key: "GeneralOperationItem",
          label: this.$t("message.contragent_search.GeneralOperationItem"),
        },
        {
          key: "ApprovedOperationItem",
          label: this.$t("message.contragent_search.ApprovedOperationItem"),
        },
      ],
      change_fields: [
        {
          key: "No",
          label: this.$t("message.contragent_search.No"),
        },
        {
          key: "ChangeName",
          label: this.$t("message.contragent_search.ChangeName"),
        },
        {
          key: "Before",
          label: this.$t("message.contragent_search.Before"),
        },
        {
          key: "After",
          label: this.$t("message.contragent_search.After"),
        },
        {
          key: "ChangeDate",
          label: this.$t("message.contragent_search.ChangeDate"),
        },
      ],
      partner_fields: [
        { key: "No", label: this.$t("message.contragent_search.No") },
        { key: "Name", label: this.$t("message.contragent_search.Name") },
        {
          key: "ShouldCapi",
          label: this.$t("message.contragent_search.ShouldCapi"),
        },
        {
          key: "ShouldDate",
          label: this.$t("message.contragent_search.ShouldDate"),
        },
        {
          key: "ShouldType",
          label: this.$t("message.contragent_search.ShouldType"),
        },
        {
          key: "RealCapi",
          label: this.$t("message.contragent_search.RealCapi"),
        },
        {
          key: "RealDate",
          label: this.$t("message.contragent_search.RealDate"),
        },
        {
          key: "RealType",
          label: this.$t("message.contragent_search.RealType"),
        },
        { key: "Form", label: this.$t("message.contragent_search.Form") },
        {
          key: "InvestmentRatio",
          label: this.$t("message.contragent_search.InvestmentRatio"),
        },
        { key: "KeyNo", label: this.$t("message.contragent_search.KeyNo") },
      ],
      invest_info_fields: [
        { key: "No", label: this.$t("message.contragent_search.No") },
        { key: "Name", label: this.$t("message.contragent_search.Name") },
        { key: "RegNo", label: this.$t("message.contragent_search.RegNo") },
        {
          key: "ShouldCapi",
          label: this.$t("message.contragent_search.ShouldCapi"),
        },
        {
          key: "ShareholdingRatio",
          label: this.$t("message.contragent_search.ShareholdingRatio"),
        },
      ],
      provide_assurance_fields: [
        { key: "No", label: this.$t("message.contragent_search.No") },
        {
          key: "Creditor",
          label: this.$t("message.contragent_search.Creditor"),
        },
        { key: "Debtor", label: this.$t("message.contragent_search.Debtor") },
        {
          key: "CreditorCategory",
          label: this.$t("message.contragent_search.CreditorCategory"),
        },
        {
          key: "CreditorAmount",
          label: this.$t("message.contragent_search.CreditorAmount"),
        },
        {
          key: "FulfillObligation",
          label: this.$t("message.contragent_search.FulfillObligation"),
        },
        {
          key: "AssuranceDurn",
          label: this.$t("message.contragent_search.AssuranceDurn"),
        },
        {
          key: "AssuranceType",
          label: this.$t("message.contragent_search.AssuranceType"),
        },
        {
          key: "AssuranceScope",
          label: this.$t("message.contragent_search.AssuranceScope"),
        },
      ],
      stock_change_fields: [
        { key: "No", label: this.$t("message.contragent_search.No") },
        { key: "Name", label: this.$t("message.contragent_search.Name") },
        { key: "Before", label: this.$t("message.contragent_search.Before") },
        { key: "After", label: this.$t("message.contragent_search.After") },
        {
          key: "ChangeDate",
          label: this.$t("message.contragent_search.ChangeDate"),
        },
      ],
      website_fields: [
        { key: "No", label: this.$t("message.contragent_search.No") },
        { key: "Type", label: this.$t("message.contragent_search.Type") },
        { key: "Name", label: this.$t("message.contragent_search.Name") },
        { key: "WebSite", label: this.$t("message.contragent_search.WebSite") },
      ],
      administration_license_fields: [
        { key: "No", label: this.$t("message.contragent_search.No") },
        { key: "Name", label: this.$t("message.contragent_search.Name") },
        { key: "EndDate", label: this.$t("message.contragent_search.EndDate") },
      ],
      branch_fields: [
        { key: "Name", label: this.$t("message.contragent_search.Name") },
        { key: "RegNo", label: this.$t("message.contragent_search.RegNo") },
        { key: "Address", label: this.$t("message.contragent_search.Address") },
        {
          key: "principal",
          label: this.$t("message.contragent_search.principal"),
        },
      ],
      employee_fields: [
        { key: "Name", label: this.$t("message.contragent_search.Name") },
        { key: "Job", label: this.$t("message.contragent_search.Job") },
        { key: "CerNo", label: this.$t("message.contragent_search.CerNo") },
        {
          key: "ScertName",
          label: this.$t("message.contragent_search.ScertName"),
        },
      ],
      assets_data_fields_1: [
        {
          key: "No",
          label: this.$t("message.contragent_search.No"),
        },
        {
          key: "Year",
          label: this.$t("message.contragent_search.Year"),
        },
        {
          key: "PublishDate",
          label: this.$t("message.contragent_search.PublishDate"),
        },
        {
          key: "TotalAssets",
          label: this.$t("message.contragent_search.TotalAssets"),
        },
        {
          key: "TotalOwnersEquity",
          label: this.$t("message.contragent_search.TotalOwnersEquity"),
        },
        {
          key: "GrossTradingIncome",
          label: this.$t("message.contragent_search.GrossTradingIncome"),
        },
        {
          key: "MainBusinessIncome",
          label: this.$t("message.contragent_search.MainBusinessIncome"),
        },
      ],
      assets_data_fields_2: [
        {
          key: "No",
          label: this.$t("message.contragent_search.No"),
        },
        {
          key: "Year",
          label: this.$t("message.contragent_search.Year"),
        },
        {
          key: "NetProfit",
          label: this.$t("message.contragent_search.NetProfit"),
        },
        {
          key: "TotalTaxAmount",
          label: this.$t("message.contragent_search.TotalTaxAmount"),
        },
        {
          key: "TotalLiabilities",
          label: this.$t("message.contragent_search.TotalLiabilities"),
        },
        {
          key: "BankingCredit",
          label: this.$t("message.contragent_search.BankingCredit"),
        },
        {
          key: "GovernmentSubsidy",
          label: this.$t("message.contragent_search.GovernmentSubsidy"),
        },
      ],
      social_insurance_fields_1: [
        {
          key: "No",
        },
        {
          key: "Year",
        },
        {
          key: "PublishDate",
        },
        {
          key: "UrbanBasicIns",
          label: this.$t("message.contragent_search.UrbanBasicIns"),
        },
        {
          key: "EmployeeBasicIns",
          label: this.$t("message.contragent_search.EmployeeBasicIns"),
        },
        {
          key: "MaternityIns",
          label: this.$t("message.contragent_search.MaternityIns"),
        },
        {
          key: "UnemploymentIns",
          label: this.$t("message.contragent_search.UnemploymentIns"),
        },
      ],
      social_insurance_fields_2: [
        {
          key: "No",
        },
        {
          key: "Year",
        },
        {
          key: "IndustrialInjuryIns",
          label: this.$t("message.contragent_search.IndustrialInjuryIns"),
        },
        {
          key: "EntUrbanBasicInsNum",
          label: this.$t("message.contragent_search.EntUrbanBasicInsNum"),
        },
        {
          key: "EntUnemploymentInsNum",
          label: this.$t("message.contragent_search.EntUnemploymentInsNum"),
        },
        {
          key: "EntEmployeeBasicInsNum",
          label: this.$t("message.contragent_search.EntEmployeeBasicInsNum"),
        },
        {
          key: "EntIndustrialInjuryInsNum",
          label: this.$t("message.contragent_search.EntIndustrialInjuryInsNum"),
        },
      ],
      social_insurance_fields_3: [
        {
          key: "No",
        },
        {
          key: "Year",
        },
        {
          key: "EntMaternityInsNum",
          label: this.$t("message.contragent_search.EntMaternityInsNum"),
        },
        {
          key: "ActUrbanBasicInsAmount",
          label: this.$t("message.contragent_search.ActUrbanBasicInsAmount"),
        },
        {
          key: "ActUnemploymentInsAmount",
          label: this.$t("message.contragent_search.ActUnemploymentInsAmount"),
        },
        {
          key: "ActEmployeeBasicInsAmount",
          label: this.$t("message.contragent_search.ActEmployeeBasicInsAmount"),
        },
        {
          key: "ActIndustrialInjuryInsAmount",
          label: this.$t(
            "message.contragent_search.ActIndustrialInjuryInsAmount",
          ),
        },
      ],
      social_insurance_fields_4: [
        {
          key: "No",
        },
        {
          key: "Year",
        },
        {
          key: "ActMaternityInsAmount",
          label: this.$t("message.contragent_search.ActMaternityInsAmount"),
        },
        {
          key: "OweUrbanBasicInsAmount",
          label: this.$t("message.contragent_search.OweUrbanBasicInsAmount"),
        },
        {
          key: "OweUnemploymentInsAmount",
          label: this.$t("message.contragent_search.OweUnemploymentInsAmount"),
        },
        {
          key: "OweIndustrialInjuryInsAmount",
          label: this.$t(
            "message.contragent_search.OweIndustrialInjuryInsAmount",
          ),
        },
        {
          key: "OweMaternityInsAmount",
          label: this.$t("message.contragent_search.OweMaternityInsAmount"),
        },
      ],
    };
  },
  mounted() {
    this.service_info = Object.entries(this.doc);
    this.results = this.doc;
    this.service_info_objects = this.service_info.filter(
      (item) =>
        typeof item[1] === "object" && item[1] !== null && !_.isArray(item[1]),
    );
    this.service_info = this.service_info.filter(
      (item) => typeof item[1] !== "object" && !_.isArray(item[1]),
    );
    setTimeout(() => {
      this.$root.$emit("print-pdf", {
        signature: "",
        type: "company-info-service-cn",
      });
    }, 2000);
  },
  computed: {},
  methods: {
    /**
     * Gets array of data-fields from the array of Results for the fields, that are arrays of objects
     * @param {Array} result – result record for company with list of results
     * @param {String} field - field to get array of
     */
    resultsDataList(result, field) {
      const results = [];
      result.results.forEach((result_) => {
        result_[field].forEach((item) => {
          results.push(item);
        });
      });
      return results;
    },
    /**
     * Gets array of data-fields from the array of Results
     * @param {Array} result – result record for company with list of results
     * @param {String} field - field to get array of
     */
    resultsData(result, field) {
      return result.results.map((result_) => {
        return {
          ...result_[field],
          Year: result_.Year,
          PublishDate: result_.PublishDate,
          No: result_.No,
        };
      });
    },
    momentum(d) {
      return moment(d).format("D.MM.Y");
    },
    // searchCompanyInfo() {
    //     axios.get(window.base+'/admin/GetBillingServiceInfo?code=430')
    // 		.then(response=>{
    // 			this.$bvModal.msgBoxConfirm(this.$t('message.find_partner.cn_company_info_check_alert') + ' ' + response.data.billing_service_price + ' ' + response.data.billing_service_cur, {
    // 				title: this.$t('message.confirm'),
    // 				size: 'sm',
    // 				buttonSize: 'sm',
    // 				okVariant: 'danger',
    // 				okTitle: this.$t('message.yes'),
    // 				cancelTitle: this.$t('message.no'),
    // 				footerClass: 'p-2',
    // 				hideHeaderClose: false,
    // 				centered: true
    // 				}).then(value => {
    // 					if(value){
    // 						axios.get(window.base + '/library/openAPIQCCMockup?keyWord=' + this.keyWord).then(response => {
    //                         this.searchComplete = true;
    //                         this.service_info = Object.entries(response.data.Result);
    //                         this.response_info = response.data.Result;
    //                         this.service_info_objects = this.service_info.filter(item => typeof item[1] === 'object' && item[1] !== null && !_.isArray(item[1]));

    //                         console.log('service info objects');
    //                         console.log(this.service_info_objects);

    //                         this.service_info = this.service_info.filter(item => typeof item[1] !== 'object' && !_.isArray(item[1]));

    //                         console.log('service info');
    //                         console.log(this.service_info);
    //                     })
    // 					}
    // 				})
    // 		})

    // }
  },
};
</script>
<style>
.pdf-annual-report-cn .table th,
.pdf-annual-report-cn .table td {
  padding: 0.75rem;
  /* padding: 0; */
  border: 1px solid;
  word-break: break-all;
}
</style>
